import { render, staticRenderFns } from "./Experiments.vue?vue&type=template&id=b3d53daa&scoped=true&"
import script from "./Experiments.vue?vue&type=script&lang=js&"
export * from "./Experiments.vue?vue&type=script&lang=js&"
import style0 from "./Experiments.vue?vue&type=style&index=0&id=b3d53daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d53daa",
  null
  
)

export default component.exports